import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PostPatientBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Mutation hook for creating a new patient for a member. Invalidates the member query on success. */
export function useCreatePatient(memberId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (body: PostPatientBody) => {
      const response = await api.post('/members/:memberId/patients', {
        params: { memberId },
        body,
      })
      if (!response.success) throw new Error(response.error.message)
      return response.data.patient
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['member', memberId] })
      queryClient.invalidateQueries({ queryKey: ['patients'] })
    },
  })
}
